import styled from "styled-components";

export const OptionSwitcherWrapper = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: ${({ width }) => width || "32px"};
  min-width: ${({ minWidth }) => minWidth || "32px"};
  height: ${({ height }) => height || "100%"};
  min-height: ${({ minHeight }) => minHeight || "124px"};
  padding: 10px 12px;
  gap: 4px;
  background: #d3e0fc;
  border-radius: 8px 0px 0px 8px;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  color: #000e2a;
  font-family: "Mona Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  overflow: visible;

  /* &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 14, 42, 0.16);
  } */
`;

export const OptionLabel = styled.span`
  width: 21px;
  height: 65px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: rotate(-90deg);
  transform-origin: center;
  white-space: nowrap;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
`;

export const OptionArrow = styled.img`
  width: 12px;
  height: 12px;
  /* transform: rotate(90deg); */
`;
